import { Box, Heading, Paragraph } from '@zillow/constellation-10';

const WhatArePayments = () => {
  return (
    <Box css={{ backgroundColor: '#e2effc', textAlign: 'center', padding: '60px 16px !important' }}>
      <Box
        css={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          gap: 'token(spacing.sm)',
          textAlign: 'center',
        }}
      >
        <Heading textStyle="heading-sm" level={2}>
          What are online rent payments?
        </Heading>
        <Paragraph css={{ maxWidth: '450px', margin: 'auto !important' }}>
          Online payments are part of a Zillow service that your landlord uses to manage your rental. You get more
          flexible ways to pay, and you both get more peace of mind.
        </Paragraph>
      </Box>
    </Box>
  );
};

export default WhatArePayments;
